import { render, staticRenderFns } from "./Title_PartnerCompany.vue?vue&type=template&id=2e8de33f&scoped=true&"
import script from "./Title_PartnerCompany.vue?vue&type=script&lang=js&"
export * from "./Title_PartnerCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8de33f",
  null
  
)

export default component.exports